export const STORAGE = {
  firstPlayer: 'mt:firstPlayer',
  dice: 'mt:dice',
  timer: 'mt:timer',
  rounds: 'mt:rounds',
  settings: 'mt:settings',
  /** Shared game name + player roster for the kit dashboard, scorecard setup, and imports */
  session: 'mt:session',
  gamePoints: 'gamePointsTracker',
  recentGames: 'recentGames',
};

/** @type {{ gameName: string, players: string[] }} */
export const DEFAULT_TABLE_SESSION = { gameName: '', players: [] };

export const dispatchPersist = (key) => {
  try {
    window.dispatchEvent(new CustomEvent('mt-persist', { detail: { key } }));
  } catch (_) {
    /* ignore */
  }
};
